// Constants file containing product IDs of products that should not be displayed in Business Centre

const INACCESSIBLE_PRODUCTS = {
  gSuiteBasicAppIds: [
    'MP-6XDHVMQ84K4THNNP2Z7W2GC28VLHRC4Q', // Demo
    'MP-XBHPSLDBHZ8Q8F57P43DPKL6SPHKHHMS', // Prod
  ],
  gSuiteBusinessAppIds: [
    'MP-GNWSMJS4BJB4Z8RZWZ8SXW6J4HP32KJ3', // Demo
    'MP-BJ37LGNT37SDN6LR7D46MPP7CBG82MN6', // Prod
  ],
  googleWorkspaceBusinessPlusAppIds: [
    'MP-8PS55DCP5DKMDPDHHPWSFPD8XCM44324', // Demo
    'MP-S2RJ778BSJR7KXFSS775BHCX383CJVSV', // Prod
  ],
  googleWorkspaceEnterpriseEssentialsAppIds: [
    'MP-35GSNMZC352XWQHN2Q588WVLW62SM27V', // Demo
    'MP-3C37DKQZ3LFVKBXJC4222KNZQPH6XCW7', // Prod
  ],
  googleWorkspaceEnterpriseStandardAppIds: [
    'MP-453NG65TC8S72CQ3NTQ4WTS3DWLLXQQH', // Demo
    'MP-MTFJDXGF8M2FFBNR282Q4SSCLPJJTZ36', // Prod
  ],
  googleWorkspaceEnterprisePlusAppIds: [
    'MP-VDNQPHCTCMHVMSNW87R8N3NRTS4HC6LV', // Demo
    'MP-FCZGBZM4ZNSGV26CCKVB6GM4F8T5Q6HG', // Prod
  ],
  gSuiteTransferAppIds: [
    'MP-7TMH5K8N7KNNRZ5NC4RNNS2JFK64HMNC', // Demo
    'MP-LMVNT4HKZCXTVDFMVT62Q6VB3ZJGNQC6', // Prod
  ],
  office365Customer: [
    'MP-GXWJBHH6PQ5HDCDXFQ2ZP4D276JCJLKH', // Demo
    'MP-MWTXLV4WDG2QCHSF2DR4JRSC4WK32DDG', // Prod
  ],
};

export function userNotRequiredProduct(id: string): boolean {
  return [
    'SM',
    'RM',
    'MS',
    'MP-0DC18874C6CE47ED96822E08934BA3D9',
    'MP-82BC9CAD4CE441EF84BC1D7865A9939F',
    'MP-9D51CB3899AC47A681B7D4FEB0608446',
    'MP-RNK47QZV7CDVZ5J53ZGLV85WBBLKRB74',
    'MP-AA5151CF1BB840819DBDF85A55E717BF',
    'MP-3QXRWPFX4BTVGZ3NBPSWPS8L3S7QS66W',
    'MP-ZZNTMG6LPHF2SMWW7PZ5W52S5WZM67Q6',
    'MP-8617C62DE46D4358B6A681433145F087',
    'MP-940E58064E2F476BB1D74E12386729B0',
    'MP-88A1EB6613BB4384A745902D186867BC',
    'MP-LD7FL5VFX68FWCP4P8FW6RW37V58PV4B',
    'MP-EE4EA04E553A4B1780CAF7AAD7BE07CD',
    'MP-C4974D390A044C28AEC31E421AA662B2',
    'MP-94072E44D5364872B672D7AB4FC7A7E8',
  ].includes(id.toUpperCase());
}

export function isGSuite(productId: string): boolean {
  return (
    INACCESSIBLE_PRODUCTS.gSuiteBasicAppIds.indexOf(productId) >= 0 ||
    INACCESSIBLE_PRODUCTS.gSuiteBusinessAppIds.indexOf(productId) >= 0 ||
    INACCESSIBLE_PRODUCTS.googleWorkspaceBusinessPlusAppIds.indexOf(productId) >= 0 ||
    INACCESSIBLE_PRODUCTS.googleWorkspaceEnterpriseEssentialsAppIds.indexOf(productId) >= 0 ||
    INACCESSIBLE_PRODUCTS.googleWorkspaceEnterpriseStandardAppIds.indexOf(productId) >= 0 ||
    INACCESSIBLE_PRODUCTS.googleWorkspaceEnterprisePlusAppIds.indexOf(productId) >= 0
  );
}
export function isGSuiteTransfer(productId: string): boolean {
  return INACCESSIBLE_PRODUCTS.gSuiteTransferAppIds.indexOf(productId) >= 0;
}
export function isOffice365(productId: string): boolean {
  return INACCESSIBLE_PRODUCTS.office365Customer.indexOf(productId) >= 0;
}

// only show Rep Man, Social Marketing,
// (The) Customer Voice,
// Ad Intel
// Appointment Scheduling, Live Chat, and Form Builder, (no particular order)
// Reputation Spy (Brands)
export const DIRECT_WEST_VISIBLE_PRODUCTS = [
  'RM',
  'SM',
  'MP-c4974d390a044c28aec31e421aa662b2',
  'MP-94072e44d5364872b672d7ab4fc7a7e8',
  'MP-0dc18874c6ce47ed96822e08934ba3d9',
  'MP-82bc9cad4ce441ef84bc1d7865a9939f',
  'MP-9d51cb3899ac47a681b7d4feb0608446',
  'Reputation Spy(RepSpy)',
];
